import axios from "axios";
import * as qs from "querystring";

const OAuth = {}

OAuth.GetToken = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "POST",
      url: "https://developer.api.autodesk.com/authentication/v2/token",
      data: qs.stringify({
        // client_id: "kbs655LahyfGTNY05s4r5Sc5focx6zLGJ8EQkFviF7M5PS5b",
        // client_secret: "OTfNqYza8i0nnqiRS0W5fHlkSHg3WmWgdVht1Twgn5JLlpPEeBChEFgY82MFYns1",
        // client_id: "jaqG7TLNj7fYExVng7G2JnEwgA9gAT0vFex19zZR6cAAEc0H",
        client_id: "YsnxyDofEbvTeQLsni62RV2I7tCDvtOjBeRIbRduAYArMIQk",
        // client_secret: "NYSc4NAC80Hs7dWJpthVAg0mODyG9q7M3hnhPGG2uDGhv6krrhnb1YGlmxp8AWE4",
        client_secret: "DTqAmUUr4rgFygN2mSxlaUIL2AvrMrQwcizSMiQ2fAtAIEh3G4AFERb9WVhs95n1",

        grant_type: "client_credentials",
        scope: "data:read data:write data:create bucket:read bucket:create",
      })
    })
    .then(response => resolve(response.data))
    .catch(error => reject(error))
  })

}
export default OAuth;
